export default () => ({
    link(scope, element, attrs, ngModel) {
        $(element).keydown(event => {
            const character = event.key;
            if (
                !(character >= '0' && character <= '9') &&
                character !== 'Backspace' &&
                character !== 'Tab' &&
                character !== 'ArrowLeft' &&
                character !== 'ArrowRight' &&
                character !== 'Delete' &&
                character !== 'End'
            ) {
                event.preventDefault();
            }
        });
    },
});
